import HospitalService from '@/services/HospitalService';

const createStore = app => {
    const state = {
        ziekenhuizen: {},
        pending: false,
        error: false
    };

    const getters = {
        getHealthcareProviders: state => state.ziekenhuizen,
        getZiekenhuizen: state => key => state.ziekenhuizen[key] || null,
        getPending: state => state.pending,
        getError: state => state.error
    };

    const actions = {
        /**
         * Zoeken van ziekenhuizen in store of anders van server.
         *
         * @param {string}   polissoortnummer   Het polissoortnummer van het pakket (100, 106).
         * @param {string}   locatie            De locatie voor het zoeken.
         *
         * @return {type} Return lijst van ziekenhuizen met contractinformatie
         */
        async findHospitals({ getters, dispatch, commit }, { polissoortnummer, locatie }) {
            const key = `${polissoortnummer}|${locatie}`;
            commit('SET_ERROR', false);

            // check bestaande zoekenhuizen
            let result = getters.getZiekenhuizen(key);
            if (result) return result;

            // opnieuw zoeken
            result = await dispatch('getContent', { polissoortnummer, locatie });
            return result;
        },

        /**
         * Ophalen van ziekenhuizen van de server.
         *
         * Gebruikt de call gethospitals van de salesfunnel client controller
         * voor het ophalen van contractinformatie voor ziekenhuizen uit mendix voor het opgegeven
         * polissoortnummer en in de buurt van de opgegeven locatie.
         *
         * @param {number}   polissoortnummer   Het polissoortnummer van het pakket (100, 106).
         * @param {string}   locatie            De locatie voor het zoeken.
         *
         * @return {type} Return lijst met ziekenhuizen met contractinformatie
         */
        async getContent({ rootGetters, commit }, { polissoortnummer, locatie }) {
            commit('START_REQUEST');

            let ziekenhuizen;
            try {
                const hospitalContent = await HospitalService.getHospitalContracts({
                    postal: locatie,
                    insurance: polissoortnummer,
                    brand: rootGetters['renderInfo/getPropositie']
                });

                // opslaan ziekenhuizen in store
                if (hospitalContent.ziekenhuizen.length > 0) {
                    ziekenhuizen = {
                        lat: hospitalContent.latitude,
                        lng: hospitalContent.longitude,
                        zorginstellingen: hospitalContent.ziekenhuizen
                    };

                    commit('SET_ZIEKENHUIZEN', { polissoortnummer, locatie, ziekenhuizen });
                }
            } catch (error) {
                commit('SET_ERROR', true);
            }

            commit('END_REQUEST');
            return ziekenhuizen || null;
        },
        clear({ commit }) {
            commit('CLEAR');
        }
    };

    const mutations = {
        START_REQUEST: state => {
            state.pending = true;
            state.error = false;
        },
        END_REQUEST: state => {
            state.pending = false;
        },
        SET_ZIEKENHUIZEN: (state, { polissoortnummer, locatie, ziekenhuizen }) => {
            const key = `${polissoortnummer}|${locatie}`;
            state.ziekenhuizen = { ...state.ziekenhuizen, [key]: ziekenhuizen };
        },
        SET_PENDING(state, value) {
            state.pending = value;
        },
        SET_ERROR(state, value) {
            state.error = value;
        },
        CLEAR(state) {
            state.ziekenhuizen = {};
            state.pending = false;
            state.error = false;
        }
    };

    return {
        namespaced: true,
        state,
        getters,
        actions,
        mutations
    };
};

export const hospitalContractsStoragePaths = ['hospitalcontracts'];

export default app => createStore(app);
